<template>
  <div class="marketing">
    <div class="title">
      <p><span @click="routeTo(`/home/application`)">营销玩法</span></p>
      <el-button type="primary"
                 size="medium"
                 plain
                 @click="showHelp">帮助中心</el-button>
    </div>
    <div class="main">
      <div class="card">
        <el-card class="search">
          <el-form ref="form"
                   :model="form"
                   inline>
            <div class="btn">
              <div>
                <el-form-item>
                  <el-button type="primary"
                             size="medium"
                             @click="Create">创建</el-button>
                </el-form-item>
                <el-form-item>
                  <el-button size="medium"
                             type="primary"
                             plain
                             @click="showHelp">使用教程</el-button>
                </el-form-item>
              </div>
              <div>
                <el-form-item>
                  <el-button size="medium"
                             type="primary"
                             plain
                             @click="reset">重置</el-button>
                </el-form-item>
                <el-form-item>
                  <el-button size="medium"
                             type="primary"
                             @click="getList(1)">查询</el-button>
                </el-form-item>
              </div>
            </div>
            <el-form-item label="活动名称："
                          style="margin-right: 40px">
              <el-input v-model="form.name"
                        placeholder="搜索活动名称"
                        clearable></el-input>
            </el-form-item>
            <el-form-item label="起止时间：">
              <el-date-picker v-model="form.date"
                              style="width: 100%"
                              type="datetimerange"
                              range-separator="至"
                              start-placeholder="开始日期"
                              end-placeholder="结束日期"
                              value-format="yyyy-MM-dd HH:mm:ss">
              </el-date-picker>
            </el-form-item>
          </el-form>
        </el-card>
        <el-card class="table">
          <el-tabs v-model="activeName"
                   @tab-click="handleClick">
            <el-tab-pane :label="item.name"
                         :name="item.type"
                         v-for="(item, index) in app_option"
                         :key="index"></el-tab-pane>
          </el-tabs>
          <div class="table">
            <el-table :data="tableData"
                      style="width: 100%"
                      v-loading="tabLoad">
              <el-table-column prop="name"
                               label="活动名称"
                               align="center">
                <template slot-scope="scope">
                  <el-tooltip v-if="scope.row.name && scope.row.name.length > 10"
                              :content="scope.row.name"
                              placement="top"
                              effect="light">
                    <span>{{ scope.row.name | strFmt }}</span>
                  </el-tooltip>
                  <span v-else>{{ scope.row.name | strFmt }}</span>
                </template>
              </el-table-column>
              <!-- 拼团 -->
              <el-table-column prop="type"
                               label="类型"
                               align="center">
                <template slot-scope="{ row }">
                  {{ row.type == 1 ? "接龙" : row.type == 2 ? "拼团" : "返现" }}
                </template>
              </el-table-column>
              <el-table-column label="开始时间"
                               prop="start_time"
                               align="center"
                               sortable> </el-table-column>
              <el-table-column label="结束时间"
                               prop="end_time"
                               align="center"
                               sortable> </el-table-column>
              <!-- 拼团 -->
              <el-table-column v-if="activeName == 'activity_team'"
                               prop="number"
                               label="开团人数"
                               align="center"
                               sortable> </el-table-column>
              <el-table-column v-if="activeName == 'activity_team'"
                               prop="activity_prepare"
                               label="有无预热"
                               align="center">
                <template slot-scope="{ row }">
                  {{ row.activity_prepare == 1 ? "有" : "无" }}
                </template>
              </el-table-column>
              <!-- 返现 -->
              <el-table-column v-if="activeName == 'activity_share'"
                               prop="reward_cash"
                               label="返现比例或金额"
                               align="center"
                               sortable>
                <template slot-scope="scope">
                  <p>{{ Number(scope.row.reward_cash) != 0 ? scope.row.reward_cash + " (元)" : scope.row.reward_share + " %" }}</p>
                </template>
              </el-table-column>
              <el-table-column v-if="activeName == 'activity_share'"
                               label="返现限制"
                               prop="limit_order_num"
                               align="center">
                <template slot-scope="{ row }">
                  {{ row.limit_order_num ? `限制每人 ${row.limit_order_num} 次` : "不限制" }}
                </template>
              </el-table-column>
              <!-- 接龙 -->
              <el-table-column v-if="activeName == 'activity_link'"
                               prop="reward_cash"
                               label="返现比例或金额"
                               sortable
                               align="center">
                <template slot-scope="scope">
                  <p>{{ Number(scope.row.reward_cash) != 0 ? scope.row.reward_cash + " (元)" : scope.row.reward_share + " %" }}</p>
                </template>
              </el-table-column>
              <el-table-column v-if="activeName == 'activity_link'"
                               label="购买限制"
                               prop="buy_limit"
                               align="center">
                <template slot-scope="{ row }">
                  {{ row.buy_limit > 0 ? `限制每人 ${row.buy_limit} 次` : "不限制" }}
                </template>
              </el-table-column>
              <!--  <el-table-column prop="type" label="活动状态" align="center">
                                <template slot-scope="{ row }">
                                    {{ row.status == 1 ? "未开始" : row.type == 2 ? "进行中"
                                     : "返现""未开始", "进行中", "已结束"
                                     }}
                                </template>
                            </el-table-column> -->
              <el-table-column label="操作"
                               align="center"
                               fixed="right">
                <template slot-scope="scope">
                  <!--  <div class="link" v-if="activeName != 'activity_link'">
                                        <el-link type="primary" @click="Detail(scope.row.id)">查看</el-link> -->

                  <div class="link">
                    <el-link type="primary"
                             @click="Detail(scope.row.id)">查看</el-link>
                    <el-link v-show="scope.row.status == 1"
                             type="primary"
                             @click="Edit(scope.row.id)">编辑</el-link>
                    <el-link v-show="scope.row.status != 4"
                             type="primary"
                             @click="getCopyData(scope.row.id)">复制</el-link>
                    <el-link v-show="scope.row.status == 1||scope.row.status == 2"
                             type="primary"
                             @click="getinvalidActivity(scope.row.id)">失效</el-link>
                    <!-- <el-link v-show="scope.row.status == 3 || scope.row.status == 1" type="danger" @click="Delete(scope.row.id)">删除</el-link> -->
                  </div>
                </template>
              </el-table-column>
            </el-table>
            <div class="pageSize">
              <el-pagination @size-change="handleSizeChange"
                             @current-change="handleCurrentChange"
                             :current-page="page"
                             :page-sizes="page_siezs"
                             :page-size="size"
                             layout="total, sizes, prev, pager, next, jumper"
                             :total="total"
                             background>
              </el-pagination>
            </div>
          </div>
        </el-card>
      </div>
      <Slide @show="showHelp"
             :dataList="dataList"></Slide>
    </div>

    <!-- 帮助中心 -->
    <Help ref="refHelp"
          :status_opt="status_opt"></Help>
    <!-- 创建编辑拼团 -->
    <CreateOrEditPT :edit_id="edit_id"
                    ref="refCreateOrEditPT"
                    @initList="initList"
                    @dataInit="dataInit"
                    :count="count"
                    @showSelDetail="showSelDetail"
                    :isDetail="isDetail"></CreateOrEditPT>
    <!-- 创建编辑返现 -->
    <CreateOrEditFX :edit_id="edit_id"
                    ref="refCreateOrEditFX"
                    @initList="initList"
                    @dataInit="dataInit"
                    :count="count"
                    @showSelDetail="showSelDetail"
                    :isDetail="isDetail"></CreateOrEditFX>
    <!-- 创建编辑接龙 -->
    <CreateOrEditJL :edit_id="edit_id"
                    ref="refCreateOrEditJL"
                    @initList="initList"
                    @dataInit="dataInit"
                    :count="count"
                    @showSelDetail="showSelDetail"
                    :isDetail="isDetail"></CreateOrEditJL>
  </div>
</template>

<script>
import { mapActions, mapGetters } from "vuex";
import Help from "@/components/Modules/Application/Help.vue";
import Slide from "@/components/Modules/Application/Slide.vue";
import CreateOrEditPT from "@/components/Modules/Application/Group/CreateOrEdit.vue"; //拼团
import CreateOrEditFX from "@/components/Modules/Application/OrderCashback/CreateOrEdit.vue"; //返现
import CreateOrEditJL from "@/components/Modules/Application/Solitaire/CreateOrEdit.vue"; //接龙
export default {
  data () {
    return {
      activeType: "拼团",
      page: 1,
      size: 10,
      total: 0,
      page_siezs: [10, 20, 30, 40],
      form: {
        status: "",
        name: "",
        date: [],
      },
      activeName: "activity_team",
      tableData: [],
      status_opt: ["全部状态", "未开始", "进行中", "已结束", "失效"],
      dataList: [],
      count: 0,
      type: 1,
      edit_id: 0,
      activityId: 0,
      isDetail: false,
      tabLoad: false,
      app_option: [],
    };
  },
  filters: {
    strFmt (val) {
      if (val) {
        if (val.length > 10) {
          return val.substring(0, 10) + "...";
        }
        return val;
      }
      return "-";
    },
  },
  components: {
    Help,
    Slide,
    CreateOrEditPT,
    CreateOrEditFX,
    CreateOrEditJL,
  },
  computed: {
    ...mapGetters(["getToken"]),
    ...mapGetters(["getAppVerify"]),
  },
  created () {
    this.verifyApp();
    if (this.$route.query.type) {
      this.activeName = this.$route.query.type;
    }
  },
  mounted () {
    this.getArticle();
    this.getList(1);
  },
  methods: {
    ...mapActions({
      // 拼团列表/merchant/activitymains/list
      getTeamList: "activity/getTeamList",
      // 订单返现列表
      /*   getActivityList: "activity/getActivityList",
        // 接龙购列表
        getLinkList: "activity/getLinkList", */
      // 拼团复制
      activityCopyCom: "activity/activityCopy",
      /*   // 拼团复制
        activityCopyTeam: "activity/activityCopyTeam",
        // 返现复制
        activityCopy: "activity/activityCopy",
        // 复制接龙
        activityCopyLink: "activity/activityCopyLink", */
      // 删除
      deleteActivityTeam: "activity/deleteActivityTeam",
      // 营销玩法-返现-删除
      deleteActivity: "activity/deleteActivity",
      // 营销玩法-接龙购-删除
      deleteActivityLink: "activity/deleteActivityLink",

      // 推荐文章列表
      getArticleApi: "activity/getArticleCategory",
      invalidActivity: "activity/invalidActivityApi",
      // 活动失效
    }),
    verifyApp () {
      this.app_option = [];
      if (this.getAppVerify.length > 0) {
        this.getAppVerify.forEach((item) => {
          let obj = {
            name: item.name,
          };
          switch (item.code) {
            case "ACTIVITY_TEAM":
              obj.type = "activity_team";
              if (item.is_free == 1 || item.merchant_status == 1) {
                this.app_option.push(obj);
              }
              break;
            case "ACTIVITY_SHARE":
              obj.type = "activity_share";
              if (item.is_free == 1 || item.merchant_status == 1) {
                this.app_option.push(obj);
              }
              break;
            case "ACTIVITY_LINK":
              obj.type = "activity_link";
              if (item.is_free == 1 || item.merchant_status == 1) {
                this.app_option.push(obj);
              }
              break;
            default:
              break;
          }
        });
      }
    },
    handleClick () {
      this.tableData = [];
      switch (this.activeName) {
        // 拼团
        case "activity_team":
          break;
        // 返现
        case "activity_share":
          break;
        //  接龙
        case "activity_link":
          break;
        default:
          break;
      }
      this.getList(1);
    },
    initList () {
      this.getList(1);
    },
    getinvalidActivity (id) {
      let params = {
        token: this.getToken,
        id: id
      };
      this.invalidActivity(params).then((res) => {
         console.log(res,'失效----')
        if (res.data.code == 1) {
 this.getList(1);
        } else {
          this.$message.error(res.data.msg);
        }
      });
    },
    getList (tag) {
      this.tabLoad = true;
      let params = {
        token: this.getToken,
        page: tag == 1 ? tag : this.page,
        size: this.size,
        /*                 search_status: this.form.status, */
        name: this.form.name,
        start_time: this.form.date ? this.form.date[0] : null,
        end_time: this.form.date ? this.form.date[1] : null,
        type: this.activeName == 'activity_team' ? 2 : this.activeName == 'activity_share' ? 3 : 1
      };
      let url = this.getTeamList;
      /*  switch (this.activeName) {
           // 拼团
           case "activity_team":
               url = this.getTeamList;
               break;
           // 返现
           case "activity_share":
               url = this.getActivityList;
               break;
           //  接龙
           case "activity_link":
               url = this.getLinkList;
               break;
           default:
               break ;
       }*/
      url(params).then(({ data }) => {
        this.tabLoad = false;
        if (data.code == 1) {
          this.total = data.data.count;
          /*  if (data.data.data) {
               this.tableData = data.data.data;
               if (data.data.count > 0 && data.data.data.length == 0) {
                   this.page -= 1;
                   this.getList();
               }
           } */
          if (data.data.list) {
            this.tableData = data.data.list;
            if (data.data.count > 0 && data.data.list.length == 0) {
              this.page -= 1;
              this.getList();
            }
          }
        } else {
          this.$message.error(data.msg);
        }
      });
    },

    dataInit () {
      this.edit_id = 0;
      this.count = 0;
    },
    Create () {
      this.isDetail = false;
      this.activityId = 0;
      this.edit_id = 0;
      switch (this.activeName) {
        // 拼团
        case "activity_team":
          this.$refs.refCreateOrEditPT.dialogVisible = true;
          break;
        // 返现
        case "activity_share":
          this.$refs.refCreateOrEditFX.dialogVisible = true;
          break;
        //  接龙
        case "activity_link":
          this.$refs.refCreateOrEditJL.dialogVisible = true;
          break;
        default:
          break;
      }
    },
    // 显示商品列表
    showSelDetail () {
      this.$refs.goodsDetail.dialogVisible = true;
    },
    getArticle () {
      let params = {
        token: this.getToken,
        code: this.activeType,
      };
      this.getArticleApi(params).then(({ data }) => {
        if (data.code == 1) {
          this.dataList = data.data.filter((item, index) => {
            return item.code.indexOf("教程") == -1 && index < 5;
          });
        } else {
          this.$message.error(data.msg);
        }
      });
    },
    Delete (id) {
      this.$confirm("是否确认删除此条数据？", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      })
        .then(() => {
          let params = {
            token: this.getToken,
            id: id,
          };
          let url;
          switch (this.activeName) {
            // 拼团
            case "activity_team":
              url = this.deleteActivityTeam;
              break;
            // 返现
            case "activity_share":
              url = this.deleteActivity;
              break;
            //  接龙
            case "activity_link":
              url = this.deleteActivityLink;
              break;
            default:
              break;
          }
          url(params).then(({ data }) => {
            if (data.code == 1) {
              this.$message.success("删除成功！");
              this.getList();
            } else {
              this.$message.error(data.msg);
            }
          });
        })
        .catch(() => {
          this.$message({
            type: "info",
            message: "已取消删除",
          });
        });
    },
    getCopyData (id) {
      let params = {
        token: this.getToken,
        id: id,
      };
      /*  let url;
       switch (this.activeName) {
           // 拼团
           case "activity_team":
               url = this.activityCopyTeam;
               break;
           // 返现
           case "activity_share":
               url = this.activityCopy;
               break;
           //  接龙
           case "activity_link":
               url = this.activityCopyLink;
               break;
           default:
               break;
       } */
      this.activityCopyCom(params).then(({ data }) => {
        if (data.code == 1) {
          this.$message.success("复制成功，请前往列表查看！");
          this.getList();
        } else {
          this.$message.error(data.msg);
        }
      });
    },
    /**
     * type - 操作类型
     * id - 操作数据id
     */
    showHelp () {
      switch (this.activeName) {
        // 拼团
        case "activity_team":
          this.activeType = "拼团";
          break;
        // 返现
        case "activity_share":
          this.activeType = "订单返现";
          break;
        //  接龙
        case "activity_link":
          this.activeType = "接龙购";
          break;
        default:
          break;
      }
      this.$refs.refHelp.dialogVisible = true;
      this.$refs.refHelp.active = JSON.parse(JSON.stringify(this.activeType));
      this.$refs.refHelp.getResult();
    },
    Detail (id) {
      this.activityId = Number(id);
      this.edit_id = Number(id);
      this.isDetail = true;
      switch (this.activeName) {
        // 拼团
        case "activity_team":
          this.$refs.refCreateOrEditPT.dialogVisible = true;
          this.$refs.refCreateOrEditPT.getDetail(id);
          break;
        // 返现
        case "activity_share":
          this.$refs.refCreateOrEditFX.dialogVisible = true;
          this.$refs.refCreateOrEditFX.getDetail(id);
          break;
        //  接龙
        case "activity_link":
          this.$refs.refCreateOrEditJL.dialogVisible = true;
          this.$refs.refCreateOrEditJL.getDetail(id);
          break;
        default:
          break;
      }
    },
    Edit (id) {
      this.activityId = Number(id);
      this.edit_id = Number(id);
      this.isDetail = false;
      switch (this.activeName) {
        // 拼团
        case "activity_team":
          this.$refs.refCreateOrEditPT.dialogVisible = true;
          this.$refs.refCreateOrEditPT.getDetail(id);
          break;
        // 返现
        case "activity_share":
          this.$refs.refCreateOrEditFX.dialogVisible = true;
          this.$refs.refCreateOrEditFX.getDetail(id);
          break;
        //  接龙
        case "activity_link":
          this.$refs.refCreateOrEditJL.dialogVisible = true;
          this.$refs.refCreateOrEditJL.getDetail(id);
          break;
        default:
          break;
      }
    },
    reset () {
      this.form = {
        status: "",
        name: "",
      };
      this.page = 1;
      this.getList(1);
    },
    routeTo (path) {
      this.$router.push({ path: path });
    },
    handleSizeChange (val) {
      this.size = val;
      this.getList();
    },
    handleCurrentChange (val) {
      this.page = val;
      this.getList();
    },
  },
};
</script>
<style lang="scss" scoped>
.marketing {
  .title {
    box-shadow: 0px 0px 8px 0px rgb(100 100 100 / 17%);
    width: 100%;
    background: #fff;
    padding: 15px 32px;
    display: flex;
    align-items: center;
    font-size: 18px;
    justify-content: space-between;
    color: #333;
    p {
      color: #333;
      span {
        margin: 0 8px;
        cursor: pointer;
        &:hover {
          color: #409eff;
        }
        &:first-child {
          margin-left: 0;
        }
        &:last-child {
          &:hover {
            color: #333;
          }
        }
      }
    }
  }
  .main {
    width: 100%;
    display: flex;
    .card {
      flex: 1;
      margin-right: 10px;
      width: 800px;
    }
  }
  .el-card {
    margin: 24px 0px 10px 24px;
    border-radius: 0;
    padding: 24px;
    &:nth-child(2) {
      margin: 10px 0px 24px 24px;
    }
  }
  .search {
    .el-form {
      .el-form-item {
        margin: 10px 6px;
      }
    }
  }
  .table {
    ::v-deep th {
      background: #fafafa !important;
    }
    ::v-deep .el-table__body-wrapper {
      min-height: 470px;
      overflow-y: auto;
    }
    .el-table::before {
      display: none;
    }
    .pageSize {
      text-align: right;
      margin-top: 20px;
    }
  }
  ::v-deep .el-card__body {
    padding: 0;
  }
  .link {
    a {
      margin: 0 8px;
    }
  }
}
::v-deep .el-table__fixed-right::before {
  display: none;
}
::v-deep .el-tabs__item {
  padding: 0 42px !important;
}
::v-deep .el-tabs__active-bar {
  width: 126px !important;
  left: -43px;
}
.btn {
  display: flex;
  justify-content: space-between;
}
</style>